import React from "react";
import { ImgV2 } from "../../ImgV2";
import { Heading } from "../../Heading";
export const CardWithImageAndGradient = ({ cardImageUrl, subTitle, title, backgroundColor, containerBackgroundColor }) => (React.createElement("div", { className: "card-with-image-gradient-root", style: { "--background-card-color": backgroundColor, "--container-background-color": containerBackgroundColor } },
    React.createElement("div", { className: "card-with-image-gradient-root__imageWrapper" },
        React.createElement(ImgV2, { src: cardImageUrl, alt: cardImageUrl })),
    React.createElement("div", { className: "card-with-image-gradient-root__textWrapper" },
        React.createElement(Heading, { design: "h3-semi-bold-small" }, title),
        React.createElement("p", { className: "caption" }, subTitle))));
